<template>
    <div>
        <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-10">
                <h4>
                    <span
                        @click="hasHistory() ? $router.go(-1) : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Ручная оценка мотивации сотрудников
                </h4>
            </div>
            <div class="col-sm-12 col-md-2 text-right">
                <b-form-select v-model="selectedMonth" :options="monthRange"></b-form-select>
            </div>
        </div>

        <div class="accordion" role="tablist">
            <b-card no-body class="mb-1" v-for="(user, user_index) in userList" :key="user_index">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                        block
                        v-b-toggle="`accordion-${user_index}`"
                        variant="white"
                        class="text-left text-secondary accordeon-user-name"
                        @click.prevent
                    >
                        <div class="d-flex align-content-center">
                            <span class="flex-grow-1">{{user.name}}</span>
                            <span class="pt-1 mr-5">
                                <span :class="bonusResults[user_index] > 0 ? 'text-success' : ''">Премия: {{bonusResults[user_index] | toCurrency}} руб.</span> /
                                <span :class="penaltyResults[user_index] > 0 ? 'text-danger' : ''">Штраф: {{penaltyResults[user_index] | toCurrency}} руб.</span>
                            </span>

                            <b-button variant="success" class="" @click.stop="saveScoringResults(user_index)">
                                <template v-if="user.saving">
                                    Сохраняю<i class="fas fa-spinner fa-spin ml-1"></i>
                                </template>
                                <template v-else>
                                    Сохранить
                                </template>
                            </b-button>
                        </div>
                    </b-button>
                </b-card-header>
                <b-collapse :id="`accordion-${user_index}`" :visible="user_index==0 ? true:false" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5 class="mb-3">Бонусы</h5>
                                    <div class="row align-items-left mb-2" v-for="(score, index) in user.bonusScores" :key="index">
                                        <div class="col-7 d-flex">
                                            <b-form-checkbox v-model="score.checked" switch class="mr-2" :disabled="isHandMotivationWasDoneInQuarter(user.id, score.id) == true ? true : false">
                                                <b>{{score.name}}</b>
                                                <template v-if="isHandMotivationWasDoneInQuarter(user.id, score.id)">
                                                    <!--{{scoredHandMotivation[user.id]['last_hand_motivation'][score.id].date_of_operation | formattedNamedDate}} года-->
                                                    <b-icon icon="exclamation-triangle" class="ml-2" v-tooltip="`Оценка этого параметра уже проводилась в этом квартале`"></b-icon>
                                                </template>
                                                <br>
                                                {{score.description}}
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col d-flex">
                                            <span class="scoringPrice text-success">{{score.value}} руб.</span>
                                        </div>
                                    </div>

                                    <template v-if="user.bonusScores.length == 0">
                                        <p class="font-italic">На данный момент, бонусы для оценки отсутствуют.</p>
                                    </template>
                                </div>
                                <div class="col-sm-6" v-if="user.fineScores.length > 0">
                                    <h5 class="mb-3">Штрафы</h5>
                                    <div class="row align-items-left mb-2" v-for="(score, index) in user.fineScores" :key="index">
                                        <div class="col-7 d-flex">
                                            <b-form-checkbox v-model="score.checked" switch class="mr-2">
                                                {{score.name}}
                                            </b-form-checkbox>
                                        </div>
                                        <div class="col d-flex">
                                            <span class="scoringPrice text-success">{{score.value}} руб.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>

        <b-overlay
            :show="loading"
            spinner-variant="success"
            no-wrap
        ></b-overlay>
    </div>
</template>

<script>
    import {
        API_USERS,
        API_GET_ALL_SETTINGS,
        API_GET_MOTIVATION,
        API_POST_MOTIVATION_MASS_SAVE_BY_HEADS,
        API_GET_MOTIVATION_LOAD_RESULTS
    } from '../constants'

    import {
        motivationWorkWithDates
    } from '../mixins/motivation/motivationHelpers'

    const HAND_BONUS_IDS = [5, 6, 21, 22]
    const TO_BONUS_LIST = [5, 6]
    const LOGIST_BONUS_LIST = [21, 22]
    const TO_FINE_LIST = [9, 10, 11, 12, 13, 14]
    const LOGIST_FINE_LIST = [15, 16, 17, 18, 19, 20]

    const TO_ROLES = [
        'TO-head-manager',
        'TO-manager'
    ]
    const LOGIST_ROLES = [
        'logistics-head-manager',
        'logistics-manager'
    ]

    export default {
        components: {
        },
        mixins: [
            motivationWorkWithDates
        ],
        data() {
            return {
                loading: false,
                additionalGetParameter: '',
                componentRefreshKey: 0,
                loadingCount: 0,
                userList: [],
                scoredMotivation: [],
                penaltyResults: [],
                bonusResults: [],
                allMotivations: [],
                scoreBonusList: [],
                scoreFineList: [],
                scoredHandMotivation: ''
            }
        },
        watch: {
            userList: {
                handler(userList) {
                    this.calcResults()
                },
                deep: true,
            },
            selectedMonth: {
                handler(value) {
                    this.loadingCount++
                    if (this.loadingCount > 1) {
                        this.clearAllMotivationData()
                        this.getMotivationSettings()
                    }
                },
            },
        },
        computed: {
            user() {
                return this.$store.getters.USER
            },
        },
        mounted() {
            if (this.$route.params.report_date) {
                this.selectedMonth = this.$route.params.report_date
            }
            this.getMotivationSettings()
        },
        methods: {
            getMotivationSettings: async function() {
                this.loading = true
                const response = await api.call('get', API_GET_ALL_SETTINGS)
                this.allMotivations = response.data
                this.allMotivations.forEach((element, index) => {
                    if (Number(element.final_value) < 0) {
                        element.final_value = -Number(element.final_value)
                        element.value = element.final_value
                        this.scoreFineList.push(element)
                    }

                    if (HAND_BONUS_IDS.includes(element.id)) {
                        element.final_value = Number(element.final_value)
                        element.value = element.final_value
                        this.scoreBonusList.push(element)
                    }
                })
                this.getUserListByParentId()
            },
            getUserListByParentId: async function() {
                this.loading = true
                if (this.onlyForHeads()) {
                    this.additionalGetParameter = 'roles=sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||TO-manager||TO-head-manager&fulldata=1&withoutFired=true'
                } else {
                    this.additionalGetParameter = 'roles=sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||TO-manager||TO-head-manager&byotdel=1&fulldata=1&withoutFired=true'
                }
                const response = await api.call('get', API_USERS + `?${this.additionalGetParameter}`)
                this.userList = response.data
                this.prepareUserListForScoring()
                this.getScoredMotivation()
                // this.loading = false
            },
            getScoredMotivation: async function() {
                this.loading = true
                const response = await api.call('get', API_GET_MOTIVATION + `?per_page=10000&date_of_operation=${this.selectedMonth}`)
                this.scoredMotivation = response.data.data
                this.prepareActualMotivationLists()
                this.getScoredHandMotivation()
            },
            getScoredHandMotivation: async function() {
                this.loading = true
                const response = await api.call('get', API_GET_MOTIVATION_LOAD_RESULTS + `?date_of_operation=${this.selectedMonth}&only_hands_results=true`)
                this.scoredHandMotivation = response.data
                this.loading = false
            },
            prepareUserListForScoring() {
                this.userList.forEach((user, index) => {
                    this.bonusResults.push(0)
                    this.penaltyResults.push(0)

                    let isToUser = user.roles.findIndex((role) => {
                        if (TO_ROLES.includes(role.slug)) {
                            return true
                        }
                    })
                    let isLogistUser = user.roles.findIndex((role) => {
                        if (LOGIST_ROLES.includes(role.slug)) {
                            return true
                        }
                    })

                    let userFines = []
                    this.scoreFineList.forEach((fine, index) => {
                        if (isToUser != -1) {
                            if (TO_FINE_LIST.includes(fine.id)) {
                                userFines.push({...fine})
                            }
                        }
                        if (isLogistUser != -1) {
                            if (LOGIST_FINE_LIST.includes(fine.id)) {
                                userFines.push({...fine})
                            }
                        }
                    })

                    this.$set(user, 'fineScores', userFines)

                    let userBonuses = []
                    this.scoreBonusList.forEach((bonus, index) => {
                        if (isToUser != -1) {
                            if (TO_BONUS_LIST.includes(bonus.id)) {
                                userBonuses.push({...bonus})
                            }
                        }
                        if (isLogistUser != -1) {
                            if (LOGIST_BONUS_LIST.includes(bonus.id)) {
                                userBonuses.push({...bonus})
                            }
                        }
                    })
                    this.$set(user, 'bonusScores', userBonuses)

                    this.$set(user, 'saving', false)

                })
            },
            prepareActualMotivationLists() {
                this.userList.forEach((user, user_index) => {
                    user.fineScores.forEach((fine, fine_index) => {
                        let findedScore = this.scoredMotivation.find((score) => {
                            if (score.motivation_setting_id == fine.id && score.manager_user_id == user.id) {
                                return score
                            }
                        })

                        if (findedScore !== undefined) {
                            if (findedScore.sum == 0) {
                                fine.checked = false
                            } else {
                                fine.checked = true
                            }
                        }
                    })

                    user.bonusScores.forEach((bonus, bonus_index) => {
                        let findedScore = this.scoredMotivation.find((score) => {
                            if (score.motivation_setting_id == bonus.id && score.manager_user_id == user.id) {
                                return score
                            }
                        })

                        if (findedScore !== undefined) {
                            if (findedScore.sum == 0) {
                                bonus.checked = false
                            } else {
                                bonus.checked = true
                            }
                        }
                    })
                })
            },
            clearAllMotivationData() {
                this.userList = []
                this.scoredMotivation = []
                this.penaltyResults = []
                this.bonusResults = []
                this.allMotivations = []
                this.scoreBonusList = []
                this.scoreFineList = []

            },
            calcResults() {
                this.userList.forEach((user, index) => {
                    this.penaltyResults[index] = 0
                    this.bonusResults[index] = 0

                    // Penalties
                    let penalties = user.fineScores.filter(field => field.checked)
                    penalties.forEach(penalty => {
                        this.penaltyResults[index] += penalty.value
                    })

                    // Bonuses
                    let bonuses = user.bonusScores.filter(field => field.checked)
                    bonuses.forEach(bonus => {
                        this.bonusResults[index] += bonus.value
                    })
                })
            },
            saveScoringResults(user_index) {
                this.userList[user_index].saving = true

                const dataForSave = {
                    'manager_user_id': this.userList[user_index].id,
                    'date_of_operation': this.selectedMonth,
                    'fineScores': this.userList[user_index].fineScores,
                    'bonusScores': this.userList[user_index].bonusScores,
                }

                api.call("post", API_POST_MOTIVATION_MASS_SAVE_BY_HEADS, dataForSave).then(({data}) => {
                    this.userList[user_index].saving = false
                    this.makeToast('success')
                }).catch((response) => {
                    this.userList[user_index].saving = false
                })
            },
            isHandMotivationWasDoneInQuarter(user_id, score_id) {
                if (this.scoredHandMotivation
                    && [5, 6].includes(score_id)
                    && this.scoredHandMotivation[user_id]['last_hand_motivation']
                    && this.scoredHandMotivation[user_id]['last_hand_motivation'][score_id] != null) {
                    return true
                }

                return false
            },
            onlyForHeads() {
                if (this.user.role && (this.user.role.includes("administrator") ||
                    this.user.role.includes("head-accountant") ||
                    this.user.role.includes("president"))) {
                    return true
                }
                return false
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
<style scoped>
    .scoringPrice {
        font-size: 24px;
        font-weight: bold;
        white-space: nowrap;
    }
    .accordeon-user-name {
        font-size: 18px;
        font-weight: bold;
    }
</style>
